enum SLARoutesAPI {
  SLA_LIST = '/customer-portal-service/Sla',
  SLA_DOWNLOAD = '/customer-portal-service/Sla/:id',
  SLA_TOTAL_TARGET = '/customer-portal-service/Sla/TotalTarget',
  SLA_TOTAL_REACHED = '/customer-portal-service/Sla/TotalReached'
}

enum SLARoutesApplication {
  SLA = '/application/sla'
}

export {
  SLARoutesAPI,
  SLARoutesApplication,
};
